import { Button } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'
import { HelpCircleIcon } from 'lucide-react'

import { LocalizedLink as Link } from '~/components/localized-link'
import { useAuth } from '~/providers/auth-provider'
import { LangSelector } from './lang-selector'
import { SolutionsPopover } from './solutions-popover'

export const GuestMenu = () => {
	const { t } = useLingui()
	const { openRegister, openLogin } = useAuth()

	return (
		<div className='flex h-full flex-row items-center gap-4 text-sm md:gap-8'>
			<SolutionsPopover />

			<Button
				className='text-base'
				data-testid='login-button'
				variant='link'
				onClick={() => openLogin()}
			>
				{t`Se connecter`}
			</Button>

			<Button
				className='text-primary text-base'
				data-testid='register-button'
				variant='textPrimary'
				onClick={() => openRegister()}
			>
				{t`S'inscrire`}
			</Button>

			<div className='flex flex-row items-center gap-2'>
				<Button
					icon
					variant='ghost'
					asChild
				>
					<Link
						href='https://support.cocoon-space.com'
						target='_blank'
					>
						<HelpCircleIcon />
					</Link>
				</Button>

				<LangSelector dense />
			</div>
		</div>
	)
}
